import React from 'react';

import * as Style from './Logo.style';

interface Props {
  src: string;
  alt?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

const Logo = (props: Props) => {
  return <Style.Logo {...props} />;
};

export default Logo;
